import React, { useEffect, useMemo, useState, useReducer } from 'react';
import { history, useIntl, getLocale } from 'umi';
import { Segment, Table } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import Filters from '../Filters';
import Visualis from '../Visualis';
import SearchAndDownload from '../Search';
import DynamicTable from '../DynamicColTable/Table';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import {
  getGenreProfilePageData,
  getGenreProfileLineChartData,
  getGenreProfilePageDataMobile,
  // getGenreProfileRegionAndCountriesListWhenOther,
  // getGenreProfileRegionAndCountriesListWhenTotalAndMobile,
} from '@/pages/intelligence/services/genreProfile';
import {
  VISUALIS_ICONS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_INDEX,
  TABLE_UNIQUE_KEY,
  DEFALUT_SORT_ORDER,
  DEFAULT_SOURCE_TYPE,
} from '../../const';
import { MARKET_GENRE_CONFIG, FETCH_KEY_MAP, PAGE_LOG_CONFIG_KEYS } from './config';
import {
  IMainEntranceProp,
  IFilter,
  IAction,
  ITableAction,
  ITableInterface,
  ITableData,
  // ISortOrder,
  ICheckChangeType,
  IPageModifiedParams,
  IChartType,
  IFetchIeggGenre,
  ILineChartOriginalData,
  ILineChartData,
  IPageConfigLineMetric,
} from '../../typings';
import type { MainGenre, SubGenre } from '@intelligence/components/GenreSelectMiddleware/types';
import { AreaItemtype } from '@/pages/intelligence/components/Filter/util';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { regionFormatter, transGenreSource } from '../../utils';
import GuideGenreMarketProfile, {
  GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/GenreMarketProfile';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import useRadioOptionsTipsGetterOfRegionSelect from '@intelligence/hooks/useRadioOptionsTipsGetterOfRegionSelect';

const reducer = (state: IFilter | ITableAction, { type, payload }: IAction) => {
  return {
    ...state,
    [type]: payload,
  };
};

const { pageable } = Table.addons;

export default function MainEntrance(props: IMainEntranceProp) {
  const { entityType = 'pc' } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const getRadioOptionsTips = useRadioOptionsTipsGetterOfRegionSelect();
  // 页面打点
  const [pageLogInfo, setPageLogInfo] = useState<any>({});
  // 表格是否loading
  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
  // 折线图是否loading
  const [isLineChartLoading, setIsLineChartLoading] = useState<boolean>(false);
  // 可视化切换按钮
  const [visualisType, setVisualisType] = useState<string>('chart-treemap');
  // 表格数据
  const [tableList, setTableList] = useState<ITableData[]>([]);
  // 接口拿到的原始表格数据
  const [originalTableList, setOriginalTableList] = useState<ITableData[]>([]);
  // 折线图数据
  const [lineChartData, setLineChartData] = useState({});
  // 接口拿到的原始折线图数据
  const [originalLineData, setOriginalLineData] = useState<ILineChartOriginalData>({});
  // 区域组件下拉数据
  const [regionOpts, setRegionOpts] = useState<AreaItemtype[]>([]);
  const [apiParams, setApiParams] = useState<any>({});

  const { filterLoading: filterLoadingPC, regionOptions: regionOptionsPC } = useMarketFilterApi({
    filterType: MarketSpecailType.digitalRevenue,
  });
  const { filterLoading: filterLoadingMobile, regionOptions: regionOptionsMobile } =
    useMarketFilterApi({
      filterType: MarketSpecailType.common,
    });
  // 筛选器选中值
  const [filter, filterDispatch] = useReducer(reducer, {
    genreSource: 'iegg',
    // genreSource: entityType === 'mobile' ? 'annie' : 'iegg',
    startDate: '',
    endDate: '',
    granularity: 'monthly',
    genreType: DEFAULT_SOURCE_TYPE,
    mainGenres: [],
    subGenres: [],
    regions: ['global'],
    markets: ['global'],
    sourceMetrics: 'sensortower',
  });

  // 从配置中拉取当前页面的配置，mobile/pc/console/total之间有区别
  const getCurrentPageConfig = ({ modifiedParams }: { modifiedParams?: IPageModifiedParams }) => {
    const targetConfig = MARKET_GENRE_CONFIG[entityType];
    const genreType = modifiedParams?.genre_tab || filter.genreType || 'mainsub';
    return {
      lineMetricList: targetConfig.lineMetricList()?.[genreType],
      tableMetricList: targetConfig.tableMetricList()?.[genreType],
      tableFirstCol: targetConfig.firstCol()?.[genreType],
      tableSpecialCol: targetConfig.specialCol()?.[genreType],
      keyMap: targetConfig.keyMap()?.[genreType],
      tableFormatter: targetConfig.tableFormatter()?.[genreType],
      lineChartFormatter: targetConfig.lineChartFormatter()?.[genreType],
      expandedTableCol:
        genreType === 'main' ? targetConfig.expandedTableCol(entityType)?.[genreType] : [],
    };
  };

  // 缓存当前页面配置
  const currentPageConfig = useMemo(() => {
    return getCurrentPageConfig({});
  }, [entityType, filter.genreType]);

  // 可视化的指标segment，切换可视化会变化
  const [lineMetric, setLineMetric] = useState<string>(
    currentPageConfig?.lineMetricList?.[0]?.value,
  );
  // 表格相关的值
  const [tableAction, tableActionDispatch] = useReducer(reducer, {
    total: 0,
    selectedTotalValue: null,
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    sortKey: '',
    sortKeyLabel: '',
    sortOrder: DEFALUT_SORT_ORDER,
    selectedList: [],
    SelectionAll: [],
  });
  /*
    // 初始化的时候从接口获取区域/国家地区组件的值
    const setRegionList = async () => {
      const result = entityType === 'mobile' || entityType === 'total'
        ? await getGenreProfileRegionAndCountriesListWhenTotalAndMobile({
          type: [{ tabName: entityType }],
          item: [{ tabName: '' }]
        })
        : await getGenreProfileRegionAndCountriesListWhenOther({
          filters: [{
            source: 'mscience',
            metric_type: 'digital-revenue'
          }]
        })
      const regionList = regionFormatter(result?.data?.region_country || []);
      setRegionOpts(regionList);
    };
  */
  // iegg和annie所传递字段是不一致的
  const getGenreParams = ({
    source,
    subGenres,
  }: {
    source: 'appannie' | 'iegg' | 'sensortower';
    subGenres: SubGenre[];
  }) => {
    const isIegg = source === 'iegg';
    const getGenreWhenAppannie = (_list: SubGenre[]) => {
      return _list?.map((item: SubGenre) => ({
        main: item.parentValue,
        sub: item.value,
      }));
    };
    const getGenreWhenIegg = (_list: SubGenre[]) => {
      const _tmpList: IFetchIeggGenre[] = [];
      _list?.forEach((item: SubGenre) => {
        const { parentValue, value } = item;
        const find = _tmpList?.find((tmpItem) => tmpItem.value === parentValue);
        const pushItem = {
          value,
        };
        if (find) {
          find.children.push(pushItem);
        } else {
          _tmpList.push({
            relation: 'or',
            value: parentValue,
            children: [pushItem],
          });
        }
      });
      return _tmpList;
    };
    if (isIegg) {
      return {
        iegg_genre_req: getGenreWhenIegg(subGenres),
        genre: [],
      };
    }
    if (source === 'sensortower') {
      return {
        iegg_genre_req: [],
        sensortower_genre: getGenreWhenAppannie(subGenres),
      };
    }
    return {
      iegg_genre_req: [],
      genre: getGenreWhenAppannie(subGenres),
    };
  };

  const changeMonthlyDateTofirstDay = (date: string) => {
    const tmpArr = date.split('-');
    tmpArr.splice(2, 1, '01');
    return tmpArr.join('-');
  };

  const handleFilterChange = ({ type, payload }: IAction) => {
    // 两次值相同则不触发更新
    // if (filter?.[type] === payload || (Array.isArray(payload) && JSON.stringify(payload) === JSON.stringify(filter?.[type]))) return;
    const modifiedParams = {};
    // 级联品类筛选器做了特殊处理
    if (type === 'cascadeGenres') {
      filterDispatch({ type: 'mainGenres', payload: payload.mainGenres });
      filterDispatch({ type: 'subGenres', payload: payload.subGenres });
      filterDispatch({ type: 'genreSource', payload: payload.source });
      Object.assign(modifiedParams, {
        genre_source: payload.source,
        subGenres: payload.subGenres,
      });
    } else if (type === 'cascadeFilter') {
      const { start_date, end_date, granularity, regions, markets } = payload;
      const _startDate =
        granularity === 'monthly' ? changeMonthlyDateTofirstDay(start_date) : start_date;
      const _endDate =
        granularity === 'monthly' ? changeMonthlyDateTofirstDay(end_date) : end_date;
      if (filter.startDate !== _startDate) {
        filterDispatch({ type: 'startDate', payload: _startDate });
        Object.assign(modifiedParams, {
          [FETCH_KEY_MAP.startDate]: _startDate,
        });
      }
      if (filter.endDate !== _endDate) {
        filterDispatch({ type: 'endDate', payload: _endDate });
        Object.assign(modifiedParams, {
          [FETCH_KEY_MAP.endDate]: _endDate,
        });
      }
      if (filter.granularity !== granularity) {
        filterDispatch({ type: 'granularity', payload: granularity });
        Object.assign(modifiedParams, { granularity });
      }
      if (JSON.stringify(filter.markets) !== JSON.stringify(markets)) {
        filterDispatch({ type: 'regions', payload: regions });
        filterDispatch({ type: 'markets', payload: markets });
        Object.assign(modifiedParams, {
          [FETCH_KEY_MAP.regions]: regions,
          [FETCH_KEY_MAP.markets]: markets,
        });
      }
    } else if (type === 'genreType') {
      filterDispatch({ type, payload });
      tableActionDispatch({ type: 'selectedList', payload: [] });
      tableActionDispatch({ type: 'SelectionAll', payload: [] });
      // const add = visualisType === 'discount-chart' ? {
      //   genre_tab: payload,
      //   genre_rank: []
      // } : {
      //   genre_tab: payload,
      // }
      Object.assign(modifiedParams, {
        genre_tab: payload,
        genre_rank: [],
      });
    } else {
      const targetKey = FETCH_KEY_MAP[type];
      filterDispatch({ type, payload });
      Object.assign(modifiedParams, {
        [targetKey]: payload,
      });
    }
    // 修改折线图到宽表接口请求之后，再调用，获取自动勾选的品类参数之后
    // if (visualisType === 'discount-chart') {
    //   setLineChart({ modifiedParams });
    //   // setLineChart(
    //   //   {
    //   //     modifiedParams: {
    //   //       genre_rank: payload
    //   //     }
    //   //   }
    //   // )
    // }
    initial({ modifiedParams });
  };

  const getGenreDetailPath = (key: string, context: any): string => {
    const _genreName = context[key];
    const _genreNameCn = context[`${key}Cn`];
    const _genreType = key === 'mainGenre' ? 'main' : 'sub';
    const _entityType = entityType === 'total' ? 'mobile' : entityType;
    const path = `/intelligence/genreProfile/${_entityType}Games/detail/insights?entityType=${_entityType}&genre=${_genreName}&genreCn=${_genreNameCn}&genreType=${_genreType}&source=${filter.genreSource}`;
    return path;
  };

  const handleGenreNameClick = (key: string, context: any): void => {
    history.push(getGenreDetailPath(key, context));
  };

  const getParams = (type: string, modifiedParams: IPageModifiedParams) => {
    const _genreType = modifiedParams?.genre_tab || filter.genreType || 'mainsub';
    const _genreSource = transGenreSource(
      modifiedParams?.genre_source || filter.genreSource || 'appannie',
    );
    const _regions = modifiedParams?.markets || filter.markets || ['global'];
    let _startDate = modifiedParams?.start_date || filter.startDate || '';
    let _endDate = modifiedParams?.end_date || filter.endDate || '';
    const _sourceMetrics = modifiedParams?.source_metrics || filter.sourceMetrics || '';

    // 时间格式错误，会出现 '-01'这种情况，导致接口告警报错。未能复现定位原因，先直接将错误格式重置
    if (_startDate === '-01') {
      _startDate = '';
    }
    if (_endDate === '-01') {
      _endDate = '';
    }

    const genreParams = getGenreParams({
      source: _genreSource,
      subGenres: modifiedParams.subGenres || filter.subGenres || [],
    });
    const params: any = {
      regions: _regions,
      entity_type: entityType,
      regionType: 'market',
      genre_tab: _genreType,
      genreSegment: _genreType === 'mainsub' ? 'all' : _genreType,
      genre_source: _genreSource,
      granularity: modifiedParams?.granularity || filter.granularity || 'monthly',
      start_date: _startDate,
      end_date: _endDate,
      ...genreParams,
      source_metrics: {
        [_sourceMetrics]: [],
      },
    };
    if (entityType !== 'mobile') delete params.source_metrics;
    if (type === 'line') {
      const _selectList =
        modifiedParams?.genre_rank ||
        handelCheckParams(
          tableAction.selectedList,
          modifiedParams?.genre_source || filter.genreSource,
        ) ||
        [];
      Object.assign(params, {
        genre_rank: _selectList,
      });
    }
    return params;
  };

  const handlePagingChange = () => {
    return pageable;
  };

  const handelCheckParams = (_selectList: ITableData[], genreSource: string) => {
    if (!_selectList) return [];
    return _selectList?.map((item) => {
      const { mainGenre, subGenre } = item;
      return {
        main_genre: mainGenre,
        sub_genre: subGenre,
        source: genreSource || filter.genreSource,
      };
    });
  };

  // 根据搜索结果过滤表格数据
  const handleFilterData = (inputValue: string) => {
    if (!inputValue) return [];
    return (
      originalTableList.filter((tableItem) => {
        const searchKey = tableItem.searchKey?.toLowerCase();
        const searchKeyCn = tableItem.searchKeyCn?.toLowerCase();
        if (locale === LANGUAGE_CN && searchKeyCn) {
          return searchKeyCn.match(inputValue?.toLowerCase());
        }
        return searchKey.match(inputValue?.toLowerCase());
      }) || []
    );
  };

  const renderTableData = (targetItem: any[]) => {
    if (!targetItem) targetItem = [];
    setIsTableLoading(true);
    const tmpArr: ITableData[] = [];
    originalTableList?.forEach((tableItem) => {
      // const find = targetItem?.find((item) => (item.searchKey || item.name)?.toLowerCase() === tableItem.searchKey?.toLowerCase());
      const find = targetItem?.find((item) => {
        const itemName = (item?.searchKey || item?.name)?.toLowerCase() || '';
        return (
          itemName === tableItem.searchKey?.toLowerCase() ||
          itemName === tableItem?.searchKeyCn?.toLowerCase()
        );
      });
      if (find) {
        tmpArr.push(tableItem);
      }
    });
    setTableList(tmpArr);
    setIsTableLoading(false);
  };

  const resetTableData = () => {
    setIsTableLoading(true);
    setTableList(processData(originalTableList, {}));
    setIsTableLoading(false);
  };

  const handleTableCheck = (list: any, status: ICheckChangeType) => {
    let checked = list;
    const isMoreThanTen = (_list: ITableData[]) => {
      return _list.length > DEFAULT_PAGE_SIZE - 1;
    };
    switch (status) {
      case 'uncheck all':
        break;
      case 'check all':
        if (tableAction.selectedList) {
          const topTen = list.slice(0, DEFAULT_PAGE_SIZE);
          checked = topTen;
        }
        break;
      case 'uncheck':
        const removedArr = tableAction.selectedList.filter(
          (item: ITableData) => item[TABLE_UNIQUE_KEY] !== list[TABLE_UNIQUE_KEY],
        );
        checked = removedArr;
        break;
      case 'check':
        if (isMoreThanTen(tableAction.selectedList)) return;
        const newArrt = tableAction.selectedList.concat(list);
        checked = newArrt;
        break;
      default:
        break;
    }
    tableActionDispatch({ type: 'selectedList', payload: checked });
    tableActionDispatch({ type: 'selectedTotalValue', payload: getTotalValue(checked) });
    if (visualisType === 'discount-chart') {
      setLineChart({
        modifiedParams: {
          genre_rank: handelCheckParams(checked, filter.genreSource),
        },
      });
    }
  };

  // 排序的时候的回调
  const handleTableSortChange = (e: SortByItemType) => {
    const { key = '', sortVal = 'desc' } = e;
    const { trueKey } = MARKET_GENRE_CONFIG.common.getTrueKey(key);
    tableActionDispatch({ type: 'sortKey', payload: trueKey });
    tableActionDispatch({ type: 'sortKeyLabel', payload: key });
    tableActionDispatch({ type: 'sortOrder', payload: sortVal });
    setTableList(
      processData(originalTableList, {
        sortKeyLabel: key,
        sortOrder: sortVal,
      }),
    );
  };

  const getIsHideCol = () => {
    return false;
  };

  const handleDateColFormat = (title: string) => {
    return title;
  };

  const changeLineChartDataByLocale = (_locale: string) => {
    if (visualisType === 'chart-treemap') return;
    setIsLineChartLoading(true);
    const _tmpObj: any = {};
    Object.keys(originalLineData).forEach((key: string) => {
      _tmpObj[key] = originalLineData[key].map((item: ILineChartData) => ({
        ...item,
        name: _locale === 'zh-CN' ? item.nameCn : item.nameEn,
      }));
    });
    setLineChartData(_tmpObj);
    setIsLineChartLoading(false);
  };

  const setLineChart = async ({ modifiedParams }: { modifiedParams: IPageModifiedParams }) => {
    setIsLineChartLoading(true);
    const result = await getGenreProfileLineChartData(getParams('line', modifiedParams));
    const { genre_trends = [] } = result?.data || {};
    const formattedLineData = currentPageConfig.lineChartFormatter({
      list: genre_trends || [],
      metricMap: currentPageConfig.lineMetricList,
      isCn: locale === 'zh-CN',
    });
    setOriginalLineData(formattedLineData);
    setLineChartData(formattedLineData);
    setIsLineChartLoading(false);
  };
  /*
  const setFilterData = async () => {
    setRegionList();
  };
  */
  const getTotalValue = (_list: ITableData[]) => {
    const tmpObj: any = {};
    _list?.forEach((item) => {
      item?.metric_list?.forEach((metricItem) => {
        const { metric, value } = metricItem;
        if (!tmpObj.hasOwnProperty(metric)) {
          tmpObj[metric] = value;
        } else {
          tmpObj[metric] += value;
        }
      });
    });
    return tmpObj;
  };

  const processData = (_list: ITableData[], modifiedParams: IPageModifiedParams) => {
    const sortKeyLabel = modifiedParams?.sortKeyLabel || tableAction.sortKeyLabel;
    const sortOrder = modifiedParams?.sortOrder || tableAction.sortOrder;
    const _genreType = modifiedParams?.genre_tab || filter.genreType || 'mainsub';
    const { sortFn } = MARKET_GENRE_CONFIG.common;
    const sortedData = sortFn(_list || [], sortKeyLabel, sortOrder);
    // 当main的时候，children也要根据sortKey排序
    if (_genreType === 'main') {
      return sortedData?.map((item: ITableData) => ({
        ...item,
        children: sortFn(item?.children || [], sortKeyLabel, sortOrder, true),
      }));
    }
    return sortedData;
  };

  const handleTableData = (
    _list: ITableInterface[],
    { modifiedParams }: { modifiedParams: IPageModifiedParams },
    params: any,
  ) => {
    if (!_list) _list = [];
    const _curPageConfig = getCurrentPageConfig({
      modifiedParams: {
        genre_tab: modifiedParams?.genre_tab,
      },
    });
    const originalTableData = _curPageConfig.tableFormatter(_list, _curPageConfig.tableMetricList);
    setOriginalTableList(originalTableData);
    tableActionDispatch({ type: 'total', payload: originalTableData.length });
    const tableData = processData(originalTableData, modifiedParams);
    const selectedTableData = tableData.slice(0, 6);
    setTableList(tableData);
    // 默认勾选前6个
    tableActionDispatch({ type: 'selectedList', payload: selectedTableData });
    tableActionDispatch({
      type: 'SelectionAll',
      payload: originalTableData.slice(0, tableAction.pageSize),
    });

    // 树形图所需的总数
    tableActionDispatch({ type: 'selectedTotalValue', payload: getTotalValue(selectedTableData) });

    // 若可视化当前为折线图，则获取最新折线图数据
    if (visualisType === 'discount-chart') {
      setLineChart({
        modifiedParams: {
          ...modifiedParams,
          genre_rank: handelCheckParams(selectedTableData, params?.genre_source),
        },
      });
    }
  };

  const setDefaultDate = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
    if (!filter.startDate) {
      filterDispatch({ type: 'startDate', payload: startDate });
    }
    if (!filter.endDate) {
      filterDispatch({ type: 'endDate', payload: endDate });
    }
  };

  const setPageData = async ({ modifiedParams }: { modifiedParams: IPageModifiedParams }) => {
    try {
      if (entityType === 'mobile') {
        const params = getParams('page', modifiedParams);

        setApiParams(params);
        const pageData = await getGenreProfilePageDataMobile(params);
        const { list: tableData = [] } = pageData?.data || {};
        const { start_date, end_date } = pageData?.req || {};
        setDefaultDate({
          startDate: start_date,
          endDate: end_date,
        });
        handleTableData(tableData || [], { modifiedParams }, params);
        setIsTableLoading(false);
        return;
      }
      const params = getParams('page', modifiedParams);

      setApiParams(params);
      const pageData = await getGenreProfilePageData(params);
      const { market_detail_stats_genre_rank: tableData = [] } = pageData?.data || {};
      const { start_date, end_date } = pageData?.req || {};
      setDefaultDate({
        startDate: start_date,
        endDate: end_date,
      });
      handleTableData(tableData || [], { modifiedParams }, params);
      setIsTableLoading(false);
    } catch (error) {
      setTableList([]);
      setIsTableLoading(false);
    }
  };

  const handleVisualisTypeChange = (type: IChartType) => {
    const findVisualis: any = VISUALIS_ICONS.find((item) => item.value === type) || {};
    setVisualisType(findVisualis.icon);
    if (type === 'line') {
      setIsLineChartLoading(true);
      setLineChart({ modifiedParams: {} });
    }
  };

  const handleDefaultSortKey = ({ modifiedParams }: { modifiedParams?: IPageModifiedParams }) => {
    const _curPageConfig = getCurrentPageConfig({
      modifiedParams: {
        genre_tab: modifiedParams?.genre_tab,
      },
    });
    const orderBy = _curPageConfig?.tableMetricList[0]?.metric;
    tableActionDispatch({ type: 'sortKey', payload: orderBy });
    tableActionDispatch({ type: 'sortKeyLabel', payload: `${orderBy}_0` });
    return {
      order: 'desc',
      order_by: orderBy,
    };
  };

  const initial = ({ modifiedParams = {} }: { modifiedParams?: IPageModifiedParams }) => {
    setIsTableLoading(true);
    const { order, order_by } = handleDefaultSortKey({ modifiedParams: {} });
    setPageData({
      modifiedParams: Object.assign(modifiedParams, {
        sortKey: order_by,
        sortKeyLabel: `${order_by}_0`,
        sortOrder: order,
      }),
    });
  };

  useEffect(() => {
    initial({});
    // setFilterData();
  }, [entityType]);

  useEffect(() => {
    if ((entityType === 'pc' || entityType === 'console') && !filterLoadingPC) {
      setRegionOpts(regionOptionsPC || []);
    }
    if ((entityType === 'mobile' || entityType === 'total') && !filterLoadingMobile) {
      setRegionOpts(regionOptionsMobile || []);
    }
  }, [entityType, filterLoadingPC, filterLoadingMobile, regionOptionsMobile, regionOptionsPC]);

  useEffect(() => {
    const pageKey = `${entityType}_${filter.genreType}`;
    const pageLogConfigKey = PAGE_LOG_CONFIG_KEYS[pageKey];
    const pageLogConfig = dbiPageLogMes[pageLogConfigKey];
    if (!pageLogConfig) return;
    buriedPointPage(pageLogConfig);
    setPageLogInfo(pageLogConfig);
  }, [entityType, filter.genreType]);

  useEffect(() => {
    changeLineChartDataByLocale(locale);
  }, [locale]);

  // 为解决此处树形图选中icon状态正常化，在不改变原有逻辑与代码的情况下做特殊处理
  const getVisualisTypeActiveTab = (visualisTypeTemp: string) => {
    return visualisTypeTemp == 'chart-treemap'
      ? 'treemap'
      : visualisTypeTemp == 'discount-chart'
      ? 'line'
      : visualisTypeTemp;
  };

  // 获取当前可视化指标名称
  const echartsMetricsCur = useMemo(() => {
    const metricList = currentPageConfig?.lineMetricList || [];
    const metricObjCur = metricList?.find((item: any) => item.value == lineMetric) || {};
    return formatMessage({ id: metricObjCur.text || '' });
  }, [lineMetric, currentPageConfig?.lineMetricList, locale]);

  return (
    <>
      <Filters
        isLoading={isTableLoading || isLineChartLoading}
        filter={filter}
        regionOpts={regionOpts}
        getRadioOptionsTips={getRadioOptionsTips}
        entityType={entityType}
        onFilterChange={handleFilterChange}
      />

      <CardSlotV2
        title={formatMessage({ id: 'dbi_genre_performance' })}
        iconList={VISUALIS_ICONS}
        activeTab={getVisualisTypeActiveTab(visualisType)}
        className="dbi-genre-card"
        getChange={(icon: IChartType) => {
          handleVisualisTypeChange(icon);
        }}
      >
        <Segment
          className="dbi-genre-card-segment"
          value={lineMetric}
          onChange={(value: string) => setLineMetric(value)}
          options={
            currentPageConfig?.lineMetricList?.map((t: IPageConfigLineMetric) => ({
              ...t,
              text: formatMessage({ id: t?.text }),
            })) || []
          }
        />
        <Visualis
          metric={lineMetric}
          isLoading={isTableLoading || isLineChartLoading}
          entityType={entityType}
          visualisType={visualisType}
          lineChartData={lineChartData}
          filter={filter}
          tableAction={tableAction}
          echartsMetricsCur={echartsMetricsCur}
        />
      </CardSlotV2>
      {!isTableLoading && (
        <SearchAndDownload
          filter={filter}
          genreParams={{
            genre: apiParams?.genre,
            sensortower_genre: apiParams?.sensortower_genre,
            genre_source: apiParams?.genre_source,
            iegg_genre_req: apiParams?.iegg_genre_req,
          }}
          total={tableAction.total}
          isLoading={isTableLoading}
          entityType={entityType}
          genreType={filter.genreType}
          pageLogInfo={pageLogInfo}
          getFilterData={handleFilterData}
          renderTableData={renderTableData}
          reset={resetTableData}
          regionOptions={regionOptionsMobile}
        />
      )}
      <CardSlotV2 iconList={[]}>
        <DynamicTable
          key={'genreProfile'}
          isExpandable={filter.genreType === 'main'}
          expandedTableCol={currentPageConfig.expandedTableCol}
          tableData={tableList}
          isLoading={isTableLoading}
          entityType={entityType}
          tableSelected={tableAction.selectedList}
          tableSelectedAll={tableAction.SelectionAll}
          total={tableAction.total}
          isNotPageableAuto={false}
          uniqueKey={'id'}
          sortKey={tableAction.sortKeyLabel}
          sortOrder={tableAction.sortOrder}
          pageSize={tableAction.pageSize}
          pageIndex={tableAction.pageIndex}
          keyMap={currentPageConfig.keyMap}
          getDateColFormat={handleDateColFormat}
          metricCol={currentPageConfig.tableMetricList}
          firstCol={currentPageConfig.tableFirstCol}
          specialCol={currentPageConfig.tableSpecialCol}
          getIsHideCol={getIsHideCol}
          pageSizeOptions={[10, 20, 50]}
          onPagingChange={handlePagingChange}
          className={GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT1}
          onSortChange={handleTableSortChange}
          onTableCheckboxChange={handleTableCheck}
          onGameItemClick={handleGenreNameClick}
          getGenreDetailPath={getGenreDetailPath}
          scrollMinWidth={entityType === 'pc' || entityType === 'console' ? 1400 : 'auto'}
        />
        {isTableLoading || <GuideGenreMarketProfile />}
      </CardSlotV2>
    </>
  );
}
